let mutations = {
    setMRecordModel(state, data) {
        // 变更mid-level-model
        let recordModel = data;
        state.mrecordModel = recordModel;
    },
    clearMRecord(state) {
        state.mrecordModel = '';
    },
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/mRecordModel/mutations.js